export default __webpack_public_path__ + "static/media/Plugged.4539b95d.svg";